import React from "react";
import Nav from "./Nav.js";
import "./style.css";
import Head from "./Header.js";
import Section from"./Section.js";
import Footer from"./Footer.js";
const App=()=>
{
return (
    <div>
    
<Nav/>
<Head/>
<Section />
<Footer/>
</div>
    );
}
export default App;